import React from 'react'
import { mount } from 'enzyme'
import loan from './testData/loan'
import EntityTab from '../EntityTab'

describe('<EntityTab />', () => {
  const entities = loan.businesses.concat(loan.businesses.reduce((acc, b) => acc.concat(b.guarantors), []))
  const noop = () => { }
  const entity = {
    name: 'Test Entity',
    title: 'OC',
    key: 'Business1'
  }
  it('renders without crashing', () => {
    mount(<EntityTab entity={entity} onClick={noop} selected={false} />)
  })
  it('should call its onClick function when it is clicked', () => {
    const onClickMock = jest.fn()
    const wrapper = mount(<EntityTab entity={entity} onClick={onClickMock} selected={false} />)
    wrapper.simulate('click')
    expect(onClickMock.mock.calls.length).toEqual(1)
  })
})